import React from 'react';
import Typography from "@mui/material/Typography";
import './Banner.css'

interface BannerProps {
    title: string;
}

const Banner: React.FC<BannerProps> = ({ title }) => {

    return (

        <div className="banner-container">
            <img src={"/Assets/banner.jpg"} alt="Background" className="background-image" />
                <div className="banner-black-overlay">
                    <Typography
                        variant= "h4"
                        sx={{ color: 'white', fontFamily: 'Poppins, sans-serif', fontSize: '40px', fontWeight: '600' }}
                    >
                        {title}
                    </Typography>
                    <div className="icons">
                        <Typography
                            sx={{ color: 'white', fontFamily: 'Poppins, sans-serif', fontSize: '20px', fontWeight: '500', paddingRight: '5%', paddingLeft: '5%' }}
                        >
                            Tenemos la experiencia para asesorarte y encontrar juntos la solución que mejor se adapte a tus necesidades. Descubre un mundo de coberturas diseñadas especialmente para ti. Tu tranquilidad y seguridad son nuestra prioridad.
                        </Typography>
                    </div>
                    <div className="icons">
                        <button className="banner-btn">
                            ¡Comunícate!
                        </button>
                    </div>
                </div>
        </div>

    );
};

export default Banner;